
import { useContext, useEffect, useRef, useState } from 'react';
import './style/job.css';
import JobDesc from './JobDesc';
import { ClientContext } from '../../../contextApi/ClientContext';
import { AppContext } from '../../../contextApi/ContextApi';

export default function Job({ website, job, inx}) {
  const {accent_color, secondary_color, primary_color} = useContext(AppContext);
  const {getJobDaysPassed} = useContext(ClientContext);
  const [daysPassed, setDaysPassed] = useState(0);
  const [isArrowHovered, setIsArrowHovered] = useState(false);
  const [isDescOpened, setIsDescOpened] = useState(false);
  const jobCardRef = useRef(null);
  useEffect(()=>{
    const handleGetDays = async()=>{
      const res = await getJobDaysPassed(job.createdAt);
      setDaysPassed(res?.message);
    }
    handleGetDays()
  },[])
  useEffect(()=>{
    if (isDescOpened) return jobCardRef.current.scrollIntoView({behavior:"smooth"})
  },[isDescOpened])
  const showDesc=()=>{
    if(isDescOpened){
      return <JobDesc job={job} inx={inx}/>
    } else{
      return null
    }
  }

  return (
    <div ref={jobCardRef} className='jobMainDiv' style={{backgroundColor:primary_color, color:accent_color, border:`0.5px solid ${accent_color}`}}>
      <h5 className='daysCounter' style={{color:secondary_color}}>{daysPassed}</h5>
      <div className='jobCard'>
        <h2 className='jobCardHeader' style={{borderLeft:`0.5px solid ${accent_color}`}}>{job?.title}</h2>
        <h4 className='jobCardDesc'>{job?.desc}</h4>
        <div className='jobCardArrow' style={{scale:isArrowHovered ? "1.4" : "1"}} onClick={()=>{setIsDescOpened(!isDescOpened)}} onMouseEnter={()=>{setIsArrowHovered(true)}} onMouseLeave={()=>{setIsArrowHovered(false)}}>▼</div>
      </div>
      {showDesc()}
    </div>
  )
}
